import { render } from "./Recover.vue?vue&type=template&id=f5f51c0a"
import script from "./Recover.vue?vue&type=script&lang=js"
export * from "./Recover.vue?vue&type=script&lang=js"

import "./Recover.vue?vue&type=style&index=0&id=f5f51c0a&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__